const network = process.env.NEXT_PUBLIC_CHAINFLIP_NETWORK;
export const isTestnet = network !== 'mainnet';
export const isPublicNetwork = network === 'mainnet' || network === 'perseverance';
export const isSudo =
  typeof window !== 'undefined' && Boolean(new URLSearchParams(window.location.search).get('sudo'));

export const isStablecoinStrategiesEnabled = !isPublicNetwork || isSudo; // TODO(1.9): Remove feature flag
export const showOnChainSwapsInLpApp = network === 'backspin' || network === 'sisyphos'; // TODO(1.9): Remove feature flag after on chain swaps is fully implemented
export const isShowStablecoinStrategiesTeaser =
  process.env.NEXT_PUBLIC_SHOW_STABLE_COIN_STRATEGIES_TEASER?.toLocaleLowerCase() === 'true'; // TODO: Remove feature flag when Stablecoin strategies are ready
